import {useMemo} from 'react';
import {useRouter} from 'next/router';
import {FiltersFromUrl} from 'plugins/modules/filter/helpers/FiltersFromUrl';
import {FiltersToApi} from 'plugins/modules/filter/helpers/FiltersToApi';
import {BrowserFilters} from 'plugins/modules/filter/helpers/BrowserFilters';
import {isBrowserContext} from 'core/helpers';
import {getTabIdFromUrl} from 'modules/stock-x/helpers/getTabIdFromUrl';

interface IProps {
    q?: string;
    section?: string;
}

export const useGetFiltersQueryData = (query: IProps = {}) => {
    const router = useRouter();

    const filterInstance = useMemo(() => {
        if (!isBrowserContext()) {
            return null;
        }

        return BrowserFilters.getInstance();
    }, []);

    return useMemo(() => {
        const {asPath} = router;

        filterInstance?.updateCurrentFiltersFromUrl();

        const {filters} = new FiltersFromUrl(asPath);
        const {query: filter} = new FiltersToApi(filters);
        const tabId = getTabIdFromUrl(asPath, router.query);

        return {
            filter,
            tabId,
            ...query,
        };
    }, [filterInstance, query, router]);
};
